import { Button } from './ui/button'
import { ImageWithFallback } from './figma/ImageWithFallback'

export function HeroSection() {
  return (
    <section id="home" className="relative bg-gradient-to-r from-[#ed8510] to-[#f97316] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className=" items-center">
        </div>
      </div>
    </section>
  )
}